module.exports = __webpack_public_path__ + "img/engine.5d3c20dd.jpg";